<div class="u-flex-full">
  <label>{{value?.title}} </label>
  <button class="close" *ngIf="value?.id" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearOffer()">
    <mat-icon>close</mat-icon>
  </button>
</div>